import { t } from "i18next";
import * as yup from "yup";

import { getIpRestrictionValidationSchema } from "./utils";

export const IP_RESTRICTIONS_ENGINE_BASE_URL = "/neeto_ip_restrictions/api/v1";

export const QUERY_KEYS = {
  IP_RESTRICTION: "IP_RESTRICTION",
  ALLOWED_IP_RANGES: "ALLOWED_IP_RANGES",
  CURRENT_IP: "CURRENT_IP",
};

export const TRUNCATE_LENGTH = 18;

export const ADDRESS_TYPE_SELECT_OPTIONS = [
  { label: t("neetoMolecules.ipRestriction.ipv4"), value: "ipv4" },
  { label: t("neetoMolecules.ipRestriction.ipv6"), value: "ipv6" },
];

export const INITIAL_VALUES = {
  ipStart: "",
  ipEnd: "",
  addressType: ADDRESS_TYPE_SELECT_OPTIONS[0].value,
};

export const VALIDATION_SCHEMA = yup.object().shape({
  ipRestriction: yup.boolean(),
  allowedIpRanges: yup.array().of(getIpRestrictionValidationSchema()),
});

export const NEW_ALLOWED_IP_RANGE = {
  ipStart: "",
  ipEnd: "",
  addressType: null,
  createdAt: new Date().toISOString(),
};
